import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
